import { render, staticRenderFns } from "./customer-otp-modal.vue?vue&type=template&id=7aa73365"
import script from "./customer-otp-modal.vue?vue&type=script&lang=js"
export * from "./customer-otp-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports